export { default } from 'shared/components/breadcrumb'
